import React, { Component } from "react";
import Card from "../Card";

import "./style.scss";

class MasonryCards extends Component {

    componentDidMount() {
        window.addEventListener("resize", this.resizeCells);
        this.resizeCells();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeCells);
    }

    resizeCells = () => {
        if(!this.masonry) return;
        let cards = this.masonry.querySelectorAll(".card");

        // let fontSize = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
        let rowHeight = parseFloat(window.getComputedStyle(this.masonry).getPropertyValue('grid-auto-rows'));
        let rowGap = parseFloat(window.getComputedStyle(this.masonry).getPropertyValue('grid-row-gap'));
        cards.forEach(card => {
            let rowSpan = Math.ceil((card.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
            card.style.gridRowEnd = "span " + rowSpan;
        });
    }

    render() {
        return (
            <>
                <section className="masonry-cards" ref={el => (this.masonry = el)}>
                    {this.props.cards.map((data, i) => {
                        return <Card
                            key={`c-0-${i}`}
                            data={data}
                            onCardUpdate={this.onCardUpdate}
                            expanded={true}
                            onLoadImage={this.resizeCells}
                        />
                    })}
                </section>
            </>
        )
    }
}

export default MasonryCards;